import { render, staticRenderFns } from "./EditWordDialog.vue?vue&type=template&id=5490c2fc&scoped=true&"
import script from "./EditWordDialog.vue?vue&type=script&lang=js&"
export * from "./EditWordDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditWordDialog.vue?vue&type=style&index=0&id=5490c2fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5490c2fc",
  null
  
)

export default component.exports